export const MapPinSvg = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 13.2812C14.2259 13.2812 15.625 11.8821 15.625 10.1562C15.625 8.43036 14.2259 7.03125 12.5 7.03125C10.7741 7.03125 9.375 8.43036 9.375 10.1562C9.375 11.8821 10.7741 13.2812 12.5 13.2812Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3125 10.1562C20.3125 17.1875 12.5 22.6562 12.5 22.6562C12.5 22.6562 4.6875 17.1875 4.6875 10.1562C4.6875 8.08425 5.5106 6.09711 6.97573 4.63198C8.44086 3.16685 10.428 2.34375 12.5 2.34375C14.572 2.34375 16.5591 3.16685 18.0243 4.63198C19.4894 6.09711 20.3125 8.08425 20.3125 10.1562V10.1562Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
